export const items = [
    {
        src: require('./assets/cats/cat1.avif'),
        alt: 'cat rowing with umbrella boat',
        matchFound: false,
    },
    {
        src: require('./assets/cats/cat2.avif'),
        alt: 'cat holding ball',
        matchFound: false,
    },
    {
        src: require('./assets/cats/cat3.avif'),
        alt: 'cat playing with sandal',
        matchFound: false,
    },
    {
        src: require('./assets/cats/cat4.avif'),
        alt: 'cat with doughnut',
        matchFound: false,
    },
    {
        src: require('./assets/cats/cat5.avif'),
        alt: 'cat flying with balloons',
        matchFound: false,
    },
    {
        src: require('./assets/cats/cat6.avif'),
        alt: 'cat falling love',
        matchFound: false,
    },
    {
        src: require('./assets/cats/cat7.avif'),
        alt: 'sitting cat and red heart',
        matchFound: false,
    },
    {
        src: require('./assets/cats/cat8.avif'),
        alt: 'cat riding bicycle and waiving hand',
        matchFound: false,
    },
    {
        src: require('./assets/cats/cat9.avif'),
        alt: 'cat holding fish bone',
        matchFound: false,
    },
    {
        src: require('./assets/cats/cat10.avif'),
        alt: 'cat looking from hole and red heart',
        matchFound: false,
    },
    {
        src: require('./assets/cats/cat11.avif'),
        alt: 'cat stretching',
        matchFound: false,
    },
    {
        src: require('./assets/cats/cat12.avif'),
        alt: 'cat wearing suit sunglasses with baseball bat',
        matchFound: false,
    },
]
